import React, {
  forwardRef,
  useRef,
  useState,
  useEffect,
  createContext,
  useContext,
} from "react";
import "react-datepicker/dist/react-datepicker.css";
import { AlertDialog, Button } from "../../../components";
import { Button as MUIButton } from "@mui/material";
import { isNonZero } from "../../../helpers/utils";
import {
  Controller,
  FormProvider,
  useForm,
  useFormState,
  useFieldArray,
  useFormContext
} from "react-hook-form";
import { Input as CInput, Text } from "@chakra-ui/react";
import { Grid, GridItem, Box, Wrap, WrapItem } from "@chakra-ui/react";
import SwitchBox from "../SwitchBox";
import { Tabs, InputNumber, DatePicker, Input, Checkbox } from "antd";
import dayjs from "dayjs";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const items = [
  {
    key: 0,
    label: `Low Tier`,
  },
  {
    key: 1,
    label: `High Tier`,
  },
];

export default function InterestRate(props) {
  const defaultValue = useRef({
    interest: "",
    startDate: "",
    endDate: "",
    scheduleDate: "",
    createdBy: null,
    updatedBy: null,
    createdUserRole: null,
    updatedUserRole: null,
    remarks1: "",
    remarks2: "",
    remarks: [],
    minimum_loan_amount: 0,
    admin_fee: 0,
    admin_fee_status: false,
    editable: true,
    modified: false,
  }).current;
  const [intTabPos, setIntTabPos] = useState(0);
  const [initialTabData, setInitialTabData] = useState([
    defaultValue,
    defaultValue,
  ]);

  const cacheFormChanges = ({ formValues, schedule }) => {
    setInitialTabData((_) => {
      let newInterestData = [..._];
      if (schedule) {
        newInterestData[intTabPos] = {
          ...newInterestData[intTabPos],
          schedule: { ...formValues, modified: true },
        };
      } else {
        newInterestData[intTabPos] = {
          ...formValues,
          modified: true,
        };
      }
      props?.setInitialProductData((_) => ({
        ..._,
        interests: newInterestData,
      }));
      return newInterestData;
    });
  };

  const onCancelChanges = ({ schedule }) => {
    const productData = props.data?.interests[intTabPos];
    setInitialTabData((_) => {
      let newInterestData = [..._];
      if (schedule) {
        let schedule = null;
        if (productData?.schedule?.interest) {
          schedule = { ...productData };
          schedule.editable = false;
        }
        newInterestData[intTabPos] = {
          ...newInterestData[intTabPos],
          schedule,
        };
      } else {
        let interest = defaultValue;
        if (productData?.interest) {
          interest = { ...productData };
          interest.editable = false;
        }
        newInterestData[intTabPos] = {
          ...interest,
        };
      }
      props?.setInitialProductData((_) => ({
        ..._,
        interests: newInterestData,
      }));
      return newInterestData;
    });
  };

  const onSaveChanges = ({ formValues, schedule }) => {
    props?.setData((_) => {
      let newData = { ..._ };
      let newInterestData = [...newData.interests];
      if (schedule) {
        formValues.editable = false;
        newInterestData[intTabPos] = {
          ...newInterestData[intTabPos],
          schedule: { ...formValues },
        };
      } else {
        formValues.editable = false;
        newInterestData[intTabPos] = {
          ...formValues,
          schedule: newInterestData[intTabPos]
            ? newInterestData[intTabPos].schedule
            : null,
        };
      }

      newData.interests = newInterestData;
      return newData;
    });
    props?.setInitialProductData((_) => {
      let newData = { ..._ };
      let newInterestData = initialTabData;
      if (schedule) {
        formValues.editable = false;
        newInterestData[intTabPos] = {
          ...initialTabData[intTabPos],
          schedule: { ...formValues },
        };
      } else {
        formValues.editable = false;

        newInterestData[intTabPos] = {
          ...formValues,
          schedule: initialTabData[intTabPos].schedule,
        };
      }

      newData.interests = newInterestData;
      return newData;
    });
  };

  useEffect(() => {
    if (props?.initialData?.interests?.length) {
      setInitialTabData([
        props?.initialData?.interests[0]
          ? props?.initialData?.interests[0]
          : defaultValue,
        props?.initialData?.interests[1]
          ? props?.initialData?.interests[1]
          : defaultValue,
      ]);
    }
  }, []);

  return (
    <div>
      {/* <Tabs
        items={items}
        className="interest_tab_sec"
        defaultActiveKey={0}
        onChange={(key) => {
          setIntTabPos(key);
        }}
      /> */}
      <div className="flex justify-between items-center mb-[10px]">
        <Tabs
          items={items}
          className="interest_tab_sec"
          defaultActiveKey={0}
          onChange={(key) => {
            setIntTabPos(key);
          }}
        />

      </div>

      <InterestRateTab
        {...props}
        productData={props?.data?.interests[intTabPos]}
        intTabPos={intTabPos}
        initialData={initialTabData[intTabPos]}
        onSaveChanges={onSaveChanges}
        onCancelChanges={onCancelChanges}
        cacheFormChanges={cacheFormChanges}
      />

    </div>
  );
}

function InterestRateTab({
  data,
  index,
  setData,
  setInitialProductData,
  initialData,
  error = "",
  isExistingProduct = false,
  formSubmitted,
  cacheFormChanges,
  onCancelChanges,
  onSaveChanges,
  ...props
}) {
  const { intTabPos, productData } = props;
  const defaultValue = useRef({
    interest: "",
    startDate: "",
    endDate: "",
    scheduleDate: "",
    createdBy: null,
    updatedBy: null,
    createdUserRole: null,
    updatedUserRole: null,
    remarks1: "",
    remarks2: "",
    remarks: [],
    minimum_loan_amount: 0,
    admin_fee: 0,
    admin_fee_status: false,
    editable: true,
  }).current;
  const [currentTabIdx, setCurrentTab] = useState(0);
  const [scheduleData, setScheduleData] = useState(null);
  const [currentTabData, setCurrentTabData] = useState(defaultValue);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (
      typeof initialData == "object" &&
      typeof initialData?.schedule == "object" &&
      initialData?.schedule
    ) {
      setScheduleData(initialData?.schedule);
    } else {
      setScheduleData(null);
    }
    if (typeof initialData == "object" && initialData) {
      setCurrentTabData(initialData);
    }
  }, [initialData]);

  const onFormChanges = ({ formValues, schedule }) => {
    cacheFormChanges({ formValues, schedule });
  };

  const onDeleteTab = ({ schedule }) => {
    setAlert({
      title: "Delete Tab Confirmation",
      description:
        "Are you sure you want to delete this tab? This action cannot be undone.",
      primary: {
        onPress: () => onDeleteTabCallback(schedule),
        buttonTxt: "Yes, Delete",
      },
      secondary: {
        onPress: () => setAlert(null),
        buttonTxt: "No",
      },
    });
  };

  const onDeleteTabCallback = (schedule) => {
    setData((_) => {
      let newData = { ..._ };
      let newInterestData = [...newData.interests];
      if (schedule) {
        newInterestData[intTabPos] = {
          ...newInterestData[intTabPos],
          schedule: null,
        };
        setScheduleData(null);
      } else {
        newInterestData[intTabPos] = {
          ...defaultValue,
          schedule: newInterestData[intTabPos].schedule
            ? newInterestData[intTabPos].schedule
            : null,
        };
        setCurrentTabData(defaultValue);
      }

      newData.interests = newInterestData;
      return newData;
    });
    setInitialProductData((_) => {
      let newData = { ..._ };
      let newInterestData = [...newData.interests];
      if (schedule) {
        newInterestData[intTabPos] = {
          ...newInterestData[intTabPos],
          schedule: null,
        };
        setScheduleData(null);
      } else {
        newInterestData[intTabPos] = {
          ...defaultValue,
          schedule: newInterestData[intTabPos].schedule
            ? newInterestData[intTabPos].schedule
            : null,
        };

        setCurrentTabData(defaultValue);
      }

      newData.interests = newInterestData;
      return newData;
    });
    setAlert(null);
  };

  const onEditClick = (schedule) => {
    if (schedule) {
      const data = { ...scheduleData };
      data.editable = true;
      setScheduleData(data);
      // cacheFormChanges({ formValues:data, schedule });
    } else {
      const data = { ...currentTabData };
      data.editable = true;
      setCurrentTabData(data);
    }
    setData((_) => {
      let newData = { ..._ };
      let newInterestData = [...newData.interests];
      if (schedule) {
        newInterestData[intTabPos] = {
          ...newInterestData[intTabPos],
          schedule: { ...scheduleData, editable: true },
        };
      } else {
        newInterestData[intTabPos] = {
          ...currentTabData,
          editable: true,
        };
      }

      newData.interests = newInterestData;
      return newData;
    });
    setInitialProductData((_) => {
      let newData = { ..._ };
      let newInterestData = [...newData.interests];
      if (schedule) {
        newInterestData[intTabPos] = {
          ...newInterestData[intTabPos],
          schedule: { ...scheduleData, editable: true },
        };
      } else {
        newInterestData[intTabPos] = {
          ...currentTabData,
          editable: true,
        };
      }

      newData.interests = newInterestData;
      return newData;
    });
  };

  const onTabChange = (index, title, value) => {
    setCurrentTab(value);
  };

  return (
    <div>
      {alert ? <AlertDialog visible={!!alert} {...alert} /> : null}
      <div className="w-full flex flex-col">
        <div className="flex mb-[-15px]">
          <SwitchBox
            tabs={[
              {
                name: "Current",
                id: 0,
                disabled: false,
              },
              {
                name: "Scheduled",
                id: 1,
                disabled: !isExistingProduct,
              },
            ]}
            activeTabIndex={currentTabIdx}
            settingsHandle={onTabChange}
          />
        </div>
        <div className="mb-2 flex w-full overflow-x-auto relative px-2 sm:px-4 py-1 sm:py-2 bg-[#F9FBFD] border border-[#F5F5F5]">
          {currentTabIdx == 1 && !scheduleData ? (
            <ViewInterest
              // fields={fields}
              data={currentTabData}
              editOpt={() => {
                setScheduleData(defaultValue);
                setInitialProductData((_) => {
                  let newData = { ..._ };
                  let newInterestData = [...newData.interests];
                  newInterestData[intTabPos] = {
                    ...newInterestData[intTabPos],
                    schedule: { ...scheduleData, editable: true },
                  };

                  newData.interests = newInterestData;
                  return newData;
                });
              }}
            />
          ) : currentTabIdx == 1 ? (
            scheduleData.editable ? (
              <EditInterest
                intTabPos={intTabPos}
                formSubmitted={formSubmitted}
                onSubmit={onSaveChanges}
                onCancelChanges={onCancelChanges}
                onFormChanges={onFormChanges}
                data={scheduleData}
                schedule
              />
            ) : (
              <ViewInterest
                onDeleteTab={onDeleteTab}
                schedule
                data={scheduleData}
                onEditClick={onEditClick}
              />
            )
          ) : currentTabData?.editable ? (
            <EditInterest
              intTabPos={intTabPos}
              formSubmitted={formSubmitted}
              onSubmit={onSaveChanges}
              onCancelChanges={onCancelChanges}
              onFormChanges={onFormChanges}
              data={currentTabData}
              schedule={false}
            />
          ) : (
            <ViewInterest
              onDeleteTab={onDeleteTab}
              schedule={false}
              data={currentTabData}
              onEditClick={onEditClick}
            />
          )}
        </div>
      </div>
    </div>
  );
}

const EditInterest = (props) => {
  const { index, tabsF } = props;
  const {
    control,
    trigger,
    formState: { errors },
    reset,
    getFieldState,
    setValue,
    watch,
    getValues,
    setFocus
  } = useFormContext();
  const {
    data,
    viewMode,
    schedule,
    onCancelChanges,
    onFormChanges,
    onSubmit,
    formSubmitted,
    intTabPos,
  } = props;
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'remarks', // ✅ now matches name={`remarks.${i}.text`}
    // name: `Interest.${index}.remarks`,
  });

  const [alert, setAlert] = useState(null);
  const methods = useForm({ defaultValues: { ...data, editable: true } });
  const { register, handleSubmit } = methods;
  const {
    formState: { isSubmitted },
    // setValue,
    clearErrors,
    setError,
    // getValues,
  } = methods;

  const [_formSubmitted, _setFormSubmitted] = useState(false);

  const formValues = watch();

  useEffect(() => {
    const remarks = getValues(`remarks`);             //1 remarks 
    if (!remarks || remarks.length === 0) {
      append({ text: "" });
    }
  }, []);
  useEffect(() => {
    (async () => {
      if (data) {
        setValue("id", data.id);
        setValue("interest", data.interest);
        setValue("startDate", data.startDate || "");
        setValue("endDate", data.endDate || "");
        setValue("scheduleDate", data.scheduleDate || "");
        setValue("minimum_loan_amount", data.minimum_loan_amount);
        setValue("admin_fee_status", data.admin_fee_status);
        setValue("admin_fee", data.admin_fee);
        loadRemarks(data.remarks)
      }

      if (formSubmitted == true) {
        // await validate();
      }
    })();
  }, [data, formSubmitted]);

  const loadRemarks = (remarks) => {
    let remarksForForm = [];

    if (remarks && remarks.length > 0) {
      remarksForForm = remarks.map((r) => ({
        id: r.id,
        text: r.text,
      }));
    } else {
      // Set default 2 empty remarks if none provided
      remarksForForm = [
        { text: "" },
        { text: "" },
      ];
    }

    replace(remarksForForm);
  };

  useEffect(() => {
    clearErrors();
  }, [intTabPos]);
  useEffect(() => {
    validate(formValues);
  }, [isSubmitted]);

  const validate = (data) => {
    let valid = true;
    clearErrors();
    if (!data?.interest) {
      setError("interest", {
        type: "manual",
        message: "Custom error message goes here",
      });

      valid = false;
    }

    if (!data?.startDate) {
      setError("startDate", {
        type: "manual",
        message: "Custom error message goes here",
      });

      valid = false;
    }

    const remarks = data.remarks || [];

    // Check all remark.text values
    for (let i = 0; i < remarks.length; i++) {
      if (!remarks[i]?.text?.trim()) {
        setError(`remarks.${i}.text`, {
          type: "manual",
          message: `Remarks ${i + 1} is required`,
        });

        if (valid) setFocus(`remarks.${i}.text`);
        valid = false;
        break;
      }
    }

    return valid;
  };

  const handleSubmitClick = async () => {

    const data = getValues();
    _setFormSubmitted(true);
    const formatedData = {
      ...data,
      id: data.id,
      interest: data.interest,
      startDate: data.startDate
        ? dayjs(data.startDate).format("YYYY/MM/DD")
        : null,
      // endDate:
      //   data?.endDate !== "" ? dayjs(data.endDate).format("YYYY/MM/DD") : null,
      endDate: data.endDate ? dayjs(data.endDate).format("YYYY/MM/DD") : null,
      scheduleDate: data?.scheduleDate
        ? dayjs(data.scheduleDate).format("YYYY/MM/DD HH:MM:ss")
        : null,
      remarks: getValues("remarks"),
      minimum_loan_amount: data.minimum_loan_amount || 0,
      admin_fee_status: data?.admin_fee_status,
      admin_fee: data?.admin_fee_status ? data.admin_fee || 0 : 0,
    };
    const valid = validate(formatedData);
    if (!valid) return;

    onSubmit({ formValues: formatedData, schedule });
  };



  const handleInterestFormat = (value) => {
    const maxLength = 5;
    if (value && value.toString().length > maxLength) {
      return value.toString().slice(0, maxLength);
    }
    return value;
  };

  useEffect(() => {
  }, [watch()]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmitClick}>
        <Box p={3}>
          {alert ? <AlertDialog visible={true} {...alert} /> : null}
          <div className="gap-x-2 gap-y-4 pb-5 flex flex-row items-center flex-wrap">
            <div className="">
              <label className="block mb-[6px] text-[13px] text-[#495159]">
                Interest Rate
              </label>
              <Controller
                control={control}
                name={`interest`}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <InputNumber
                      type="number"
                      status={
                        (isSubmitted || _formSubmitted) && !formValues?.interest
                          ? "error"
                          : null
                      }
                      maxLength={5}
                      prefix="%"
                      formatter={handleInterestFormat}
                      parser={handleInterestFormat}
                      step="0.01"
                      precision={2}
                      placeholder="0"
                      className={`cusAdmInputNumber2 percentage arrHid `}
                      onChange={(val) => {
                        field.onChange(val);
                      }}
                      value={field?.value}
                    />
                  );
                }}
              />
            </div>

            <div className="flex flex-row items-center">
              <div className="flex flex-col">
                <label className="block mb-[6px] text-[13px] text-[#495159]">
                  Publish Date
                </label>
                <Controller
                  control={control}
                  name="startDate"
                  rules={{ required: true }}
                  render={({ field }) => (
                    <DatePicker
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                      onChange={(date) => {
                        const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : null;
                        field.onChange(formattedDate);
                      }}
                      disabledDate={(d) => d.isBefore(dayjs().subtract(1, "day"))}
                    />
                  )}
                />
              </div>

              <div className="flex flex-col mx-2">
                <label className="opacity-0">To</label>
                <div className="h-[40px] pt-[8px] w-[25px] items-center flex">
                  <label className="">To</label>
                </div>
              </div>

              <div className="flex flex-col">
                <div className="flex items-center">
                  <div style={{ marginLeft: "-10px" }}>
                    <label className="block mb-[6px] text-[13px] text-[#495159]">
                      End Date
                    </label>
                    <div className="">
                      <Controller
                        control={control}
                        name="endDate"
                        render={({ field }) => (
                          <DatePicker
                            placeholder="DD-MM-YYYY"
                            format="DD-MM-YYYY"
                            value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                            onChange={(date) => {
                              const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : null;
                              field.onChange(formattedDate); 
                            }}
                            disabledDate={(d) =>
                              d.isBefore(dayjs(getValues("startDate"), "YYYY-MM-DD"))
                            } 
                            className="py-[8px]"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {schedule && (
              <div className="">
                <label className="block mb-[6px] text-[13px] text-[#495159]">
                  Schedule At
                </label>
                <Controller
                  control={control}
                  name="scheduleDate"
                  render={({ field, fieldState }) => {
                    return (
                      <DatePicker
                        showTime
                        placeholder="DD-MM-YYYY HH:MM"
                        format="DD-MM-YYYY HH:mm"
                        name={field.name}
                        ref={field.ref}
                        className="py-[8px]"
                        value={
                          field.value ? dayjs(field.value).minute(0) : null
                        }
                        onChange={(date) => {
                          field.onChange(date ? date?.valueOf() : null);
                          onFormChanges({
                            formValues: {
                              ...formValues,
                              scheduleDate: date?.valueOf(),
                            },
                            schedule,
                          });
                        }}
                        onOk={(date) => {
                          field.onChange(date ? date?.valueOf() : null);
                        }}
                        minuteStep={60}
                        disabledDate={(d) =>
                          d.isBefore(dayjs().subtract(1, "days"))
                        }
                      />
                    );
                  }}
                />
              </div>
            )}
          </div>
          <div className="mb-[20px]">
            {fields.map((field, i) => (
              <div style={{ display: "flex" }}>
                <div key={field.id} className="flex items-start gap-2 mb-[15px]" style={{ width: "95%" }}>
                  {/* Input Field */}
                  <div className="flex-1" >
                    <label className="block text-[13px] text-[#495159] mb-[6px]">
                      {`Remarks ${i + 1}`}
                    </label>
                    <Controller
                      control={control}
                      name={`remarks.${i}.text`}
                      rules={{
                        required: {
                          value: true,
                          message: `Remarks ${i + 1} is required`,
                        },
                        validate: (value) =>
                          value?.trim() !== '' || `Remarks ${i + 1} cannot be empty`,
                      }}
                      // rules={{ required: i === 0 || i === 1 ? "Required" : false }}
                      render={({ field, fieldState }) => (
                        <Input
                          {...field}
                          status={fieldState.error ? "error" : null}
                          placeholder={`Remarks ${i + 1}`}
                          className="py-[8px] w-full"
                        />
                      )}
                    />
                  </div>
                </div>
                {i > 0 && (<MUIButton
                  danger
                  onClick={() => remove(i)}
                  startIcon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
                  style={{ marginTop: '22px', marginRight: '-20px', width: "10%", height: '40px', width: '40px', minWidth: '40px' }}
                >
                </MUIButton>)}
              </div>
            ))}

            <MUIButton
              onClick={() => append({ text: "" })}
              startIcon={<PlusOutlined />}
              style={{ textTransform: 'capitalize' }}
            >
              Add More Remarks
            </MUIButton>
          </div>

          <div className="grid gap-x-4 gap-y-4 grid-cols-12 sm:grid-cols-12 pb-5">
            <div className="col-span-5 sm:col-span-3">
              <label className="block mb-[6px] text-[13px] text-[#495159]">
                Min. Loan Criteria
              </label>
              <Controller
                control={control}
                name={`minimum_loan_amount`}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <InputNumber
                      type="number"
                      min={0}
                      style={{ borderColor: "#C3D2E2" }}
                      {...field}
                      prefix="$"
                      prefixCls="num_pref_icon"
                      step="1"
                      precision={2}
                      onChange={(data) => {
                        field.onChange(data);
                        // onFormChanges({
                        //   formValues: {
                        //     ...formValues,
                        //     minimum_loan_amount: data,
                        //   },
                        //   schedule,
                        // });
                        if (data > 0) {
                          setValue("minimum_loan_amount", data);
                        } else {
                          setValue("minimum_loan_amount");
                          setValue("admin_fee", 0);
                        }
                      }}
                      placeholder="0"
                      value={field.value}
                      className={`cusAdmInputNumber`}
                    />
                  );
                }}
              />
            </div>
            {viewMode ? null : (
              <div className="flex flex-col items-center justify-center col-span-1 sm:col-span-1 ">
                <label className="opacity-0"> d</label>
                <div className="flex items-center justify-center">
                  <Controller
                    control={control}
                    name={`admin_fee_status`}
                    render={({ field }) => {
                      return (
                        <Checkbox
                          checked={data?.admin_fee_status}
                          onChange={(e) => {
                            field.onChange(e.target.checked);
                            // onFormChanges({
                            //   formValues: {
                            //     ...formValues,
                            //     admin_fee_status: e.target.checked,
                            //   },
                            //   schedule,
                            // });
                          }}
                          disabled={
                            watch("minimum_loan_amount") == 0 ||
                            watch("minimum_loan_amount") === null ||
                            watch("minimum_loan_amount") === undefined ||
                            watch("minimum_loan_amount") === "0.00"
                          }
                        />
                      );
                    }}
                  />
                </div>
              </div>
            )}
            <div className="col-span-6 flex flex-col sm:col-span-4 ">
              <label className="block mb-[6px] text-[13px] text-[#495159]">
                Else + Admin Fee
              </label>
              <div className="flex items-center ">
                <Controller
                  control={control}
                  name={"admin_fee"}
                  render={({ field }) => {
                    return (
                      <InputNumber
                        disabled={formValues.admin_fee_status != true}
                        type="number"
                        min={0}
                        style={{ borderColor: "#C3D2E2" }}
                        {...field}
                        prefix="$"
                        prefixCls="num_pref_icon"
                        step="1"
                        precision={2}
                        onChange={(data) => {
                          field.onChange(data);
                          // onFormChanges({
                          //   formValues: {
                          //     ...formValues,
                          //     admin_fee: data,
                          //   },
                          //   schedule,
                          // });
                        }}
                        value={field.value}
                        placeholder="0"
                        className={`cusAdmInputNumber`}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="col-span-12 sm:col-span-4">
              <label>Statement Preview</label>
              <Box height="2.5rem" display="flex" alignItems="center">
                <Text
                  overflowWrap="break-word"
                  noOfLines={2}
                  className="text-[13px] font-medium whitespace-wrap"
                >
                  {`${formValues?.minimum_loan_amount &&
                    isNonZero(formValues?.minimum_loan_amount)
                    ? `Min. Loan $${formValues?.minimum_loan_amount}`
                    : ""
                    } ${formValues?.admin_fee_status &&
                      formValues?.admin_fee &&
                      isNonZero(formValues.admin_fee)
                      ? ` else + $${formValues.admin_fee} admin fee`
                      : ""
                    }`}
                </Text>
              </Box>
            </div>
          </div>
          <div className="mt-5">
            <Button
              // disabled={}
              type="button"
              onClick={handleSubmitClick}
              className="sav_btn"
              title="Save Changes"
            />
            <Button
              type="button"
              className="can_btn"
              onClick={() => onCancelChanges({ schedule })}
              title="Cancel"
            />
          </div>
        </Box>
      </form>
    </FormProvider>
  );
};

const ViewInterest = (props) => {
  const { data, schedule, onEditClick, onDeleteTab, editOpt, fieldsCount, } = props;

  // const methods = useForm({
  //   defaultValues: {
  //     ...data,
  //     remarks: data?.remarks || [],
  //   },
  // });

  const methods = useForm({
    defaultValues: {
      ...fieldsCount,
      remarks:
        fieldsCount?.remarks?.length > 0
          ? fieldsCount.remarks
          : [{ text: "" }],
    },
  });

  const {
    register,
    control,
    reset,
    formState: { errors },
    setValue,
    getValues,
  } = methods;
  useEffect(() => {
    if (data) {
      setValue("id", data.id);
      setValue("interest", data.interest);
      setValue("startDate", data.startDate);
      setValue("endDate", data.endDate);
      setValue("scheduleDate", data.scheduleDate);
      setValue("minimum_loan_amount", data.minimum_loan_amount);
      setValue("admin_fee_status", data.admin_fee_status);
      setValue("admin_fee", data.admin_fee);
      setValue("remarks", data.remarks);
    }
    return () => { };
  }, [data]);
  return (
    <>
      {!editOpt ? null : (
        <div
          className="absolute inset-0 flex flex-col items-center justify-center"
          style={{ zIndex: 999999 }}
        >
          <div className="h-[250px] w-full  flex flex-col items-center justify-center p-[25px_15px]">
            <p className="text-[#5F7585] text-[14px] font-[500] mb-[17px]">
              Seems like you don’t have any schedule
            </p>
            <Button
              type="button"
              className="sav_btn nosched"
              title="Schedule Now"
              onClick={() => props.editOpt()}
            />
          </div>
        </div>
      )}
      <div
        className={` relative ${editOpt ? "opacity-0" : ""}`}
        onClick={(e) => {
          if (!editOpt) {
            e.stopPropagation();
          }
        }}
      >
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(null)} noValidate>
            <Box p={3}>
              <div className="gap-x-2 gap-y-4 pb-5 flex flex-row items-center flex-wrap">
                <div className="">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Interest Rate
                  </label>
                  <Controller
                    control={control}
                    name={`interest`}
                    render={({ field }) => {
                      return (
                        <InputNumber
                          type="number"
                          maxLength={5}
                          disabled
                          prefix="%"
                          width={"85px"}
                          style={{ borderColor: "transparent" }}
                          precision={2}
                          className={`cusAdmInputNumber2 percentage arrHid disabled-input-number bg-transparent border-transparent hover:shadow-none hover:border-transparent`}
                          value={field.value}
                          defaultValue={data?.interest}
                        />
                      );
                    }}
                  />
                </div>
                <div className="flex flex-row items-center">
                  <div className="flex flex-col">
                    <label className="block mb-[6px] text-[13px] text-[#495159]">
                      Publish Date
                    </label>
                    <Controller
                      control={control}
                      name="startDate"
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <DatePicker
                            disabled
                            format="DD-MM-YYYY"
                            name={field.name}
                            ref={field.ref}
                            locale={"enSG"}
                            className="py-[8px]"
                            value={field.value ? dayjs(field.value) : null}
                            defaultValue={
                              data?.startDate ? dayjs(data?.startDate) : ""
                            }
                            onChange={(date, dateString) => {
                              field.onChange(date, dateString);
                              setValue("endDate", "");
                            }}
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="flex flex-col mx-2">
                    <label className="opacity-0">To</label>
                    <div className="h-[40px] pt-[8px] w-[25px] items-center flex">
                      <label className="">To</label>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="flex items-center">
                      <div style={{ marginLeft: "-10px" }}>
                        <label className="block mb-[6px] text-[13px] text-[#495159]">
                          End Date
                        </label>
                        <div className="">
                          <Controller
                            control={control}
                            locale={"enSG"}
                            name="endDate"
                            render={({ field, fieldState }) => {
                              return data?.startDate && !data?.endDate ? (
                                <InputNumber
                                  type="text"
                                  size="large"
                                  disabled
                                  className="disabled-input-number w-[125px] bg-transparent border-transparent hover:shadow-none hover:border-transparent"
                                  defaultValue={"Further Notice"}
                                />
                              ) : (
                                <DatePicker
                                  disabled
                                  format="DD-MM-YYYY"
                                  name={field.name}
                                  ref={field.ref}
                                  locale={"enSG"}
                                  className={`py-[8px] disabled-datepicker`}
                                  value={
                                    field.value ? dayjs(field.value) : null
                                  }
                                  defaultValue={
                                    data?.endDate ? dayjs(data?.endDate) : ""
                                  }
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {schedule && (
                  <div className="">
                    <label className="block mb-[6px] text-[13px] text-[#495159]">
                      Schedule At
                    </label>
                    <Controller
                      control={control}
                      name="scheduleDate"
                      locale={"enSG"}
                      render={({ field, fieldState }) => {
                        return data?.scheduleDate ? (
                          <DatePicker
                            showTime
                            disabled
                            locale={"enSG"}
                            format="DD-MM-YYYY HH:mm"
                            name={field.name}
                            ref={field.ref}
                            className="py-[8px] disabled-datepicker"
                            value={field.value ? dayjs(field.value) : null}
                            defaultValue={
                              data?.scheduleDate
                                ? dayjs(data?.scheduleDate)
                                : ""
                            }
                            disabledDate={(d) =>
                              d.isBefore(dayjs().subtract(1, "days"))
                            }
                          />
                        ) : (
                          <InputNumber
                            type="text"
                            size="large"
                            disabled
                            className="w-[100%] disabled-input-number bg-transparent border-transparent hover:shadow-none hover:border-transparent"
                          />
                        );
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="pb-5">

                {data.remarks && data.remarks.map((field, i) => (
                  <div>
                    <label className="text-[#27272B] text-[13px] mb-[10px] inline-block">
                      Remark {i + 1}
                    </label>
                    <div className="mb-[10px]">
                      <Controller
                        control={control}
                        name={`remarks1`}
                        render={({ field1 }) => {
                          return (
                            <InputNumber
                              type="text"
                              size="large"
                              disabled
                              className="w-[100%] disabled-input-number bg-transparent border-transparent hover:shadow-none hover:border-transparent"
                              value={field.text}
                            />
                          );
                        }}
                      />
                    </div></div>))}
              </div>

              <div className="grid gap-x-4 gap-y-4 grid-cols-12 sm:grid-cols-12 pb-5">
                <div className="col-span-5 sm:col-span-3">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Min. Loan Criteria
                  </label>
                  <Controller
                    control={control}
                    name={`minimum_loan_amount`}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => {
                      return (
                        <InputNumber
                          type="number"
                          min={0}
                          disabled
                          precision={2}
                          className={`cusAdmInputNumber disabled-input-number bg-transparent border-transparent hover:shadow-none hover:border-transparent`}
                          value={field.value}
                          defaultValue={data?.minimum_loan_amount}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-span-7 flex flex-col sm:col-span-4 items-center">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Else + Admin Fee
                  </label>
                  <Controller
                    control={control}
                    name={`admin_fee`}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => {
                      return (
                        <InputNumber
                          type="number"
                          disabled
                          precision={2}
                          min={0}
                          className={`cusAdmInputNumber disabled-input-number bg-transparent border-transparent hover:shadow-none hover:border-transparent`}
                          value={field.value}
                          defaultValue={data?.admin_fee}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-span-12 sm:col-span-5">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Statement Preview
                  </label>
                  <Box height="2.5rem" display="flex" alignItems="center">
                    <Text
                      overflowWrap="break-word"
                      noOfLines={2}
                      className="text-[13px] font-medium whitespace-wrap"
                    >
                      {`${data?.minimum_loan_amount &&
                        isNonZero(data?.minimum_loan_amount)
                        ? `Min. Loan $${data?.minimum_loan_amount}`
                        : ""
                        } ${data?.admin_fee_status &&
                          data?.admin_fee &&
                          isNonZero(data.admin_fee)
                          ? ` else + $${data.admin_fee} admin fee`
                          : ""
                        }`}
                    </Text>
                  </Box>
                </div>
              </div>
              <div className="mt-5">
                <Button
                  type="button"
                  className="sav_btn"
                  onClick={() => onEditClick(schedule)}
                  title="Edit"
                />
                <Button
                  type="button"
                  className="warn_btn ml-2"
                  onClick={() => onDeleteTab({ schedule })}
                  title="Delete"
                />
              </div>
            </Box>
          </form>
        </FormProvider>
      </div>
    </>
  );
};
